module.exports = __webpack_public_path__ + "media/store/images/facebook-b2ae030b313fd0f0dbf14e1f84ffd603.svg";